import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18InfoG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      transform: "translate(3.067 3.067)",
      children: [/*#__PURE__*/jsx("circle", {
        cx: 8.826,
        cy: 5.918,
        r: 1
      }), /*#__PURE__*/jsx("rect", {
        width: 1.412,
        height: 5.815,
        x: 8.119,
        y: 7.579,
        rx: 0.706
      }), /*#__PURE__*/jsx("path", {
        d: "M8.933 0a8.933 8.933 0 1 0 0 17.867A8.933 8.933 0 0 0 8.933 0m0 1.867a7.067 7.067 0 1 1 0 14.133 7.067 7.067 0 0 1 0-14.133"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18InfoG$1 = Svg18InfoG;

export { Svg18InfoG$1 as default };
